/** import external dependencies */
import 'jquery';
import { decode as jwtDecode } from 'jwt-simple';

/** import local dependencies */
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import calculator from './routes/calculator';
import successStories from './routes/successStories';

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
  /** All pages */
  common,
  /** Home page */
  home,
  /** About Us page, note the change from about-us to aboutUs. */
  aboutUs,
  calculator,
  successStories,
});

/** Load Events */
jQuery(document).ready(() => routes.loadEvents());

/**
 * When the route changes in the Client App, take care of a few items such as:
 * - Close the Mobile Menu
 * - Making sure to check if the user is authenticated to update the site via a CSS class
 * NOTE: This currently runs within main.js so that it happens quickly and reduces FOUC
 */
const onRouteChange = function onRouteChange() {
  const body = document.body;

  // Hide mobile menu on path change
  const mobileMenuOpenClass = 'has-mobile-menu-open';
  if (body.className.indexOf(mobileMenuOpenClass) >= 0 ) {
    document.body.className = body.className.replace(mobileMenuOpenClass, '')
  }

  // Ensure the `is-authenticated` is never left on by accident
  body.className = body.className.replace(' is-authenticated', '');

  // Confirm localStorage is available
  if (!localStorage) {
    return;
  }

  const localToken = localStorage.getItem('jwt');

  // Leave if no localToken is found
  if (!localToken){
    return;
  }

  const jwt = jwtDecode(localToken, null, true);

  // Confirm a decoded jwt was returned
  if (!jwt) {
    return;
  }

  // Determine if the user is logged in based on the expiration date for the jwt
  const isLoggedIn = jwt.exp > Math.floor(new Date().getTime()/1000);

  if (isLoggedIn) {
    body.className += ' is-authenticated';
  }
};
onRouteChange();

// Add a listener firing from the Client App to run authenticationCheck on navigation changes
document.addEventListener('DEAL_SHIELD/NAVIGATE', onRouteChange, false);
document.addEventListener('DEAL_SHIELD/PRINT', function(ev) {
  const detail = ev.detail || {};
  if (detail.hideFooter) {
    const footer = $('.site-footer');
    const printingClass = 'hidden';
    footer.addClass(printingClass);
    setTimeout(() => footer.removeClass(printingClass), 500);
  }

}, false);

// Window scope functions used by the React app
window.setAlerts = function(alerts) {
  window.setAlertCount(alerts.length);
  // TODO: Populate flyout with alert data
};
window.setAlertCount = function(alertCount) {
  var label = alertCount > 50 ? '50+' : alertCount;
  jQuery('.js-alert-count').text(label).toggleClass('hidden', !alertCount);
};



// WEBPACK FOOTER //
// ./scripts/main.js